import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { MatrixService } from 'src/app/core/service/api/matrix.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent implements OnInit {
  issuesList: any;
  title: string;
  message: string;
  cancelText: string;
  confirmText: string;

  // eslint-disable-next-line no-empty-function
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _matrixService: MatrixService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    // Required properties: title, message, cancelText, and confirmText must be provided in data
    if (!this.data?.title || !this.data?.message || !this.data?.cancelText || !this.data?.confirmText) {
      console.error('ConfirmationDialogComponent: Missing required properties. Please provide title, message, cancelText, and confirmText in the data object.');
      return;
    }

    this.title = this.data.title;
    this.message = this.data.message;
    this.cancelText = this.data.cancelText;
    this.confirmText = this.data.confirmText;

    // Only fetch issue interest if stakeholderId and interestId are provided (specific use case)
    if (this.data?.stakeholderId && this.data?.interestId) {
      this._matrixService.getIssueInterest(this.data.stakeholderId, '', this.data.interestId).subscribe(
        (issuesList: any) => {
          this.issuesList = issuesList
        },
        error => {
          console.error('There was an error!', error);
        })
    }
  }

  submit(d) {
    if(d) {
      // For specific issue interest case, return issuesList; for generic case, return true
      this.dialogRef.close(this.issuesList || true);
    } else {
      this.dialogRef.close();
    }
  }
}
